/* @flow */
import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';
import createDebugger from 'debug';

const debug = createDebugger('app:modules:marketplace:epics'); // eslint-disable-line no-unused-vars

import { REGISTER_APM_ENDPOINT, marketplaceApmParams} from '../tracking/constants.js';

import {
  REGISTER_ACTIVITY,
} from './action-types.js';


export default combineEpics();



// WEBPACK FOOTER //
// ./src/app/modules/marketplace/epics.js